// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1MOL-","marker":"Header_marker__2R3Ra"};